export default __webpack_public_path__ + "static/media/clock-512.40867bde.png";